const PublicFooter = () => {
  return (
    <footer className="public-footer">
      <div className="public-footer-inner">
        <div className="footer-brand">
          <img className="brand-logo" src="/logoMain.png" alt="Trelledex logo" />
          <div>
            <img
              className="footer-wordmark"
              src="/company-name.png"
              alt="Trelledex"
            />
            <p className="footer-subtitle">Data services, reporting &amp; software implementations</p>
          </div>
        </div>
        <div className="footer-columns">
          <div>
            <p className="footer-heading">Company</p>
            <a href="/about">About</a>
            <a href="/core-solutions">Core Solutions</a>
            <a href="/news">News</a>
            <a href="/contact">Contact</a>
          </div>
          <div>
            <p className="footer-heading">Products</p>
            <a href="/products">Data</a>
            <a href="/products">Reporting</a>
            <a href="/products">Software</a>
          </div>
          <div>
            <p className="footer-heading">Resources</p>
            <span>Industry coverage</span>
            <span>Deal trackers</span>
            <span>Research briefs</span>
          </div>
          <div>
            <p className="footer-heading">Contact</p>
            <a href="mailto:trelledex@gmail.com">trelledex@gmail.com</a>
            <span>+27 67 752 8778</span>
            <span>Sandton, Johannesburg</span>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© 2026 Trelledex. All rights reserved.</span>
        <div className="footer-bottom-links">
          <span>Privacy</span>
          <span>Terms</span>
          <span>Security</span>
          <a className="footer-partner" href="/app">
            Partner Portal
          </a>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
